import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Cookie } from './cookie';

@Injectable()
export class AppLoaderService {
  private envUrl = this.getRequestUrl('/api/auth/self');

  constructor(private http: HttpClient) {}

  // Get url from window
  getRequestUrl(path: string): string {
    return `${window.location.protocol}//${window.location.host}` + (path ? path : ``);
  }

  // Check for self auth
  getAPI(url: string): Observable<any> {
    const _token = Cookie.get('_token');
    if (!_token) {
      return of(false);
    }
    const headers = new Headers({ 'Content-Type': 'application/json', Authorization: _token });
    return this.http.get(url).pipe(
      map((response: Response) => response),
      catchError(this.handleError),
    );
  }

  // Error handler
  handleError(error: Response) {
    return of(error);
  }

  // Remove auth cookie and storage
  removeAuthCookie() {
    const host = window.location.hostname === 'localhost' ? '' : `.${this.getHost().host}`;
    localStorage.removeItem('_activeUser');
    Cookie.delete('_token', '/', host);
    Cookie.delete('_google_token', '/', host);
    Cookie.delete('_host', '/', host);
  }

  // Get host for removing cookies
  getHost() {
    if (window.location.hostname !== 'localhost') {
      const rawHost = window.location.host.split('.');
      const hosts: any = [];
      const nonHosts: any = [];
      rawHost.forEach((innerHost: any, index: number) => {
        if (index >= rawHost.length - 2) {
          hosts.push(innerHost);
        } else if (index === rawHost.length - 3) {
          hosts.push(innerHost);
        } else {
          nonHosts.push(innerHost);
        }
      });
      return {
        host: hosts.join('.'),
        nonHost: nonHosts.join('.'),
      };
    } else {
      return {
        host: window.location.host,
        nonHost: '',
      };
    }
  }

  // check for auth
  public load(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getAPI(this.envUrl).subscribe((response: any) => {
        if (response && (response.status === 401 || response.status === 403)) {
          this.removeAuthCookie();
        }
        resolve(true);
      });
    });
  }
}
